import { ReactElement } from 'react';

import { StyledText } from './styles';
import { TextElements, TextProps } from './types';

const Text = ({
	align,
	children,
	className,
	color,
	el,
	letterSpacing,
	lineHeight,
	noMargin,
	opacity,
	size,
	uppercase,
	verticalAlign,
	weight,
	styleAs,
	srOnly,
	...htmlProps
}: TextProps): ReactElement => {
	return (
		<StyledText
			as={el ?? TextElements.Span}
			className={className}
			$align={align}
			$color={color}
			$letterSpacing={letterSpacing}
			$lineHeight={lineHeight}
			$noMargin={noMargin}
			$opacity={opacity}
			$size={size}
			$uppercase={uppercase}
			$verticalAlign={verticalAlign}
			$weight={weight}
			$styleAs={styleAs}
			$srOnly={srOnly}
			{...htmlProps}
		>
			{children}
		</StyledText>
	);
};

export default Text;
